<article
  class="review-detail-card"
  [class.review-detail-card--address]="cardLayout() === 'address'"
  [class.review-detail-card--details]="cardLayout() === 'details'"
  [attr.data-testid]="testId() || null"
>
  <header class="review-detail-card__header">
    <puro-typography component="h3" variant="body1" class="review-detail-card__title">
      {{ title() }}
    </puro-typography>
    @if (showEdit()) {
      <puro-button
        type="button"
        variant="link"
        class="review-detail-card__edit"
        data-testid="review-edit"
        (buttonClick)="onEdit()"
      >
        {{ 'createShipment.reviewAndPay.edit' | translate }}
      </puro-button>
    }
  </header>
  <div class="review-detail-card__body">
    <ng-content />
  </div>
</article>
